import React, { useState } from 'react';

import classNames from 'classnames';
import DatePicker from 'components/cosmos/date-picker';
import Icon from 'components/icons';
import { translate } from 'components/translate';
import I18n from 'components/translate/I18n';
import PropTypes from 'prop-types';

import {
  DRIPPING_OPTION,
  OPTIONS,
  DAYS_OPTIONS,
  DRIPPING_PARAMS
} from './constants';

import './DrippingSelectionStep.scss';

const DrippingSelectionStep = ({ onDrippingChange, t }) => {
  const [drippingChecked, setDrippingChecked] = useState(false);
  const [selectedDay, setDay] = useState(null);
  const [showCustomInput, setShowCustomInput] = useState(false);

  const isDrippingOptionChecked = (option) => drippingChecked === option;

  const setSelectedType = (type) => {
    onDrippingChange({
      [DRIPPING_PARAMS.type]: type,
      [DRIPPING_PARAMS[DRIPPING_OPTION.BY_DATE]]: null,
      [DRIPPING_PARAMS[DRIPPING_OPTION.BY_DAYS]]: null
    });
  };

  const onRadioChange = (e) => {
    const newValue = e.target.value;
    const typeValue =
      newValue === DRIPPING_OPTION.DEFINE_LATER ? null : newValue;

    setDrippingChecked(e.target.value);
    setSelectedType(typeValue);
  };

  const setSelectedDate = (dateResponse) => {
    onDrippingChange({
      [DRIPPING_PARAMS[DRIPPING_OPTION.BY_DATE]]: dateResponse.dateTime
    });
  };

  const setSelectedDay = (value) => {
    setDay(value);
    onDrippingChange({ [DRIPPING_PARAMS[DRIPPING_OPTION.BY_DAYS]]: value });
  };

  const selectDayOption = (option) => {
    setShowCustomInput(false);
    setSelectedDay(option);
  };

  const openCustomInput = () => {
    setSelectedDay(null);
    setShowCustomInput(true);
  };

  const renderDayDrippingOption = () => (
    <>
      <div className="dripping-selection__day">
        {DAYS_OPTIONS.map((option) => (
          <button
            key={option}
            onClick={() => selectDayOption(option)}
            className="hot-button _mr-2"
          >
            <I18n label="general.n_days_plural" data={{ days: option }} />
          </button>
        ))}
        <button
          onClick={openCustomInput}
          className={classNames({ selected: showCustomInput }, 'hot-button')}
        >
          <I18n label="general.custom" />
        </button>
      </div>
      {showCustomInput && (
        <div className="dripping-selection__custom">
          <input
            type="text"
            className="hot-form__input hot-form__input--md"
            value={selectedDay}
            placeholder={t(
              'content_list.content_duplication.dripping_custom_placeholder'
            )}
            name="custom-dripping"
            onChange={(e) => setSelectedDay(e.target.value)}
          />
          <div className="dripping-selection__custom__description">
            <I18n
              label="content_list.content_duplication.dripping_custom_description"
              html
            />
          </div>
        </div>
      )}
    </>
  );

  const renderDateDrippingOption = () => (
    <DatePicker
      placeholder="content_list.content_duplication.date_placeholder"
      onChange={setSelectedDate}
    />
  );

  return (
    <div className="dripping-selection">
      <div className="module-selection__page-list">
        <h3 className="module-selection__page-list__modules_question">
          <I18n label="content_list.content_duplication.dripping_selection" />
        </h3>
      </div>
      <div>
        <div className="dripping-selection__options">
          {OPTIONS.map((item) => (
            <div
              className="hot-form hot-form--custom hot-form--radio"
              key={item.name}
            >
              <input
                type="radio"
                className="hot-form__input"
                id={item.name}
                value={item.value}
                name={item.name}
                onChange={onRadioChange}
                checked={isDrippingOptionChecked(item.value)}
              />
              <label className="hot-form__label" htmlFor={item.name}>
                <I18n label={item.label} />
                {item.icon && (
                  <Icon prefix="far" iconName={item.icon} className="_ml-2" />
                )}
              </label>
            </div>
          ))}
        </div>
        {isDrippingOptionChecked(DRIPPING_OPTION.BY_DAYS) &&
          renderDayDrippingOption()}
        {isDrippingOptionChecked(DRIPPING_OPTION.BY_DATE) &&
          renderDateDrippingOption()}
      </div>
    </div>
  );
};

DrippingSelectionStep.propTypes = {
  onDrippingChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired
};

export default translate('Translate')(DrippingSelectionStep);
